module.exports = {
  isAnalyticsEnabled: true,
  isMonitoringEnabled: false, // TODO: Enable this when we have an active Sentry account
  segmentKey: '9wAnhgBtnGAcd4GfUZ2XYZthfsO57cj2',
  sentryDSNUrl: 'https://137959a3415946af8bb1545650eb4556@sentry.io/1449059',
  supportedFeatureFlags: [
    'f_override_lock',
  ],
  supportedLanguages: [
    'en',
    'es',
    'wd', // Test language used only in dev
  ],
};
